const ToolbarGroupContainer = ( props ) => (
	<div className={ props.className }>
		{ props.children }
	</div>
);
export default ToolbarGroupContainer;
